<div class="embedded-content" data-testid="smart-fix-embedded-panel">
  <h2 class="heading-5"><i class="fa-light fa-lightbulb-on mr-8"></i>Let's try this first</h2>

  <p class="body mt-8">Your {{ vm.productType | lowercase }} might have a clogged filter. (It’s very common.)</p>
  <p class="body mb-16 sm-mb-12 mob-margin">
    Luckily, this is quick and easy to fix. And you could get things working again right away.
  </p>

  @if (!videoOpen) {
    <p class="body bold mb-8">Our step-by-step video will walk you through it.</p>
    <p class="body mt-8 fix-time"><i class="fa-light fa-timer mr-8"></i>Fix time: only a few minutes</p>

    <app-button
      dataLabel="watch-video-guide"
      [buttonOptions]="{
        variant: 'secondary',
        type: 'button',
      }"
      class="min-w-160 mt-16"
      (click)="onOpenVideoGuide()"
    >
      Watch our video guide
    </app-button>
  } @else {
    <p class="body bold">Before you start, be sure to:</p>
    <ol>
      <li class="body mt-8">Turn off the {{ vm.productType | lowercase }}</li>
      <li class="body">Unplug it from the power</li>
    </ol>

    <app-smart-fix-video-player
      class="mt-16"
      [videoUrl]="youtubeUrl"
      [offset]="videoOffset"
      (videoClicked)="onVideoClicked()"
      (videoLoaded)="onVideoLoaded()"
    ></app-smart-fix-video-player>
    <p class="hint mt-8">
      Please follow the instructions carefully. We take responsibility if you follow them correctly and they’re not
      right. But we’re not responsible for any issues if this guidance isn’t followed properly.
    </p>

    <p class="hint mt-8">
      For more help and safety information, check the 'warnings' section in your appliance manual.
    </p>

    <p class="body mt-16">We hope this has helped you solve the issue.</p>

    <p class="body bold mb-12 mt-16">Or do you still need to book a repair?</p>
    <div class="radio-buttons">
      @for (option of repairOptions; track option; let index = $index) {
        <app-radio-button
          [index]="index"
          [optionValue]="option"
          [includeResetOption]="false"
          (change)="onAnswerSelected(option)"
          variant="blue"
          [tabbable]="true"
          data-testid="repair-options"
        >
          {{ option }}
        </app-radio-button>
      }
    </div>
    @if (showError) {
      <section class="error mt-16 mb-16">
        <i class="fa-light fa-circle-exclamation"></i>
        <p class="body">Select an option to continue.</p>
      </section>
    }
  }
</div>
